import { LegalClientSaveActivityParam } from 'api/types/params';
import { isYes } from 'helpers';

import { CompanyActivityFormType } from '../../forms/companyActivityForm';

export const getSubmitData = (
  values: CompanyActivityFormType
): LegalClientSaveActivityParam => ({
  activity: values.activity.value,
  isLargeEnterprise: isYes(values.isLargeEnterprise),
  isNominalHolder: isYes(values.isNominalHolder),
  requiresNominalHoldingSubaccount: isYes(
    values.requiresNominalHoldingSubaccount
  ),
  otherActivity: values.otherActivity,
});
